import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import api from '../services/api';

const DocumentsPage = () => {
  // State for active category filter and documents
  const [activeCategory, setActiveCategory] = useState('all');
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [availableCategories, setAvailableCategories] = useState([]);
  
  // Hardcoded tenders data - you can replace this with API call later
  const [tenders] = useState([
    {
      id: 't1',
      name: 'Procurement of Manpower Service',
      category: 'TENDERS',
      date: '2025-09-04',
      description: 'Bidding Document'
    },
   
  ]);
  
  // Fetch documents on component mount
  useEffect(() => {
    fetchDocuments();
  }, []);

  // Fetch documents from API
// Add this temporary debug version to your fetchDocuments function
const fetchDocuments = async () => {
  try {
    setLoading(true);
    setError(null);
    
    // Debug: Check what URL is actually being built
    console.log('api.BASE_URL:', api.BASE_URL);
    const fullUrl = `${api.BASE_URL}/public/docs`;
    console.log('Full URL being called:', fullUrl);
    
    // Try to fetch and log everything
    const response = await fetch(fullUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    console.log('Response status:', response.status);
    console.log('Response statusText:', response.statusText);
    console.log('Response URL:', response.url);
    
    // Log response headers
    console.log('Response headers:');
    for (let [key, value] of response.headers.entries()) {
      console.log(`${key}: ${value}`);
    }
    
    if (!response.ok) {
      // Try to get error details
      const errorText = await response.text();
      console.log('Error response body:', errorText);
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    
    const data = await response.json();
    console.log('Success response data:', data);
    
    // Rest of your existing logic...
    if (data && data.data && Array.isArray(data.data)) {
      const docs = sortDocumentsNewest(data.data || []);
      setDocuments(docs);
      
      const categories = [...new Set(docs.map(doc => doc.category).filter(Boolean))];
      setAvailableCategories(categories);
      setError(null);
    } else {
      setError(data.message || 'Failed to fetch documents');
    }
  } catch (err) {
    console.error('Detailed error:', err);
    setError('Error fetching documents: ' + err.message);
  } finally {
    setLoading(false);
  }
};
  // Latest/current documents must always be shown first.
  const getDocumentDateValue = (doc) => {
    if (!doc) return 0;

    const candidates = [
      doc.date,
      doc.uploadDate,
      doc.updated_at,
      doc.updatedAt,
      doc.created_at,
      doc.createdAt
    ];

    for (const value of candidates) {
      if (!value) continue;
      const parsed = new Date(value).getTime();
      if (!Number.isNaN(parsed)) return parsed;
    }

    const numericId = Number(doc.id || 0);
    return Number.isNaN(numericId) ? 0 : numericId;
  };

  const sortDocumentsNewest = (items = []) => {
    return [...items].sort((a, b) => {
      const dateDiff = getDocumentDateValue(b) - getDocumentDateValue(a);
      if (dateDiff !== 0) return dateDiff;

      const bId = Number(b?.id || 0);
      const aId = Number(a?.id || 0);

      return (Number.isNaN(bId) ? 0 : bId) -
             (Number.isNaN(aId) ? 0 : aId);
    });
  };

  // All Documents includes tenders too.
  const filteredDocuments = sortDocumentsNewest(
    activeCategory === 'tenders'
      ? tenders
      : activeCategory === 'all'
        ? [...tenders, ...documents]
        : documents.filter(doc => doc.category === activeCategory)
  );

// Build categories for filter dynamically
  const categories = [
    { id: 'all', name: 'All Documents' },
    { id: 'tenders', name: 'Tenders' },
    ...availableCategories.map(category => ({
      id: category,
      name: category.toUpperCase()
    }))
  ];

  // Format file size (if available)
  const formatFileSize = (bytes) => {
    if (!bytes) return 'Unknown size';
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  // Format date (if available)
  const formatDate = (dateString) => {
    if (!dateString) return 'Unknown date';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };
/*
  // Handle download for regular documents
  const handleDownload = (doc) => {
    const url = `https://crd-training.in/uploads/${doc.file}`;
    
    // Create a hidden iframe to trigger download
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    iframe.style.width = '0';
    iframe.style.height = '0';
    
    // Set the source to trigger download
    iframe.src = url;
    
    // Append to body
    document.body.appendChild(iframe);
    
    // Clean up the iframe after some time
    setTimeout(() => {
      try {
        document.body.removeChild(iframe);
      } catch (e) {
        // Ignore if already removed
      }
    }, 5000);
    
    // Also try the traditional method as backup
    setTimeout(() => {
      const link = document.createElement('a');
      link.href = url;
      link.download = doc.name.endsWith('.pdf') ? doc.name : `${doc.name}.pdf`;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }, 1000);
  };

  // Handle tender download (direct file access)
  const handleTenderDownload = (tender) => {
    // Direct link to the PDF file, not the directory
    const url = `https://crd-training.in/tender.pdf`;
    const link = document.createElement('a');
    link.href = url;
    link.download = 'Procurement_of_Manpower_Service.pdf';
    link.style.display = 'none';
    link.target = '_blank'; // Add target blank as fallback
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Handle tender view (open in new tab)
  const handleTenderView = (tender) => {
    // Direct link to the PDF file, not the directory
    const url = `https://crd-training.in/tender.pdf`;
    window.open(url, '_blank');
  };
*/

const encodeDocumentPath = (filePath) => {
  return String(filePath || '')
    .trim()
    .replace(/\\/g, '/')
    .replace(/^\/+/, '')
    .split('/')
    .filter(Boolean)
    .map((part) => encodeURIComponent(part))
    .join('/');
};

const getDocumentUrlCandidates = (filePath) => {
  if (!filePath) return [];

  const cleanPath = String(filePath).trim();

  if (/^https?:\/\//i.test(cleanPath)) {
    return [cleanPath];
  }

  const origin =
    typeof window !== 'undefined'
      ? window.location.origin
      : 'https://crd-training.in';

  const encodedPath = encodeDocumentPath(cleanPath);
  if (!encodedPath) return [];

  const withoutUploads = encodedPath.replace(/^uploads\//i, '');
  const withoutDocs = withoutUploads.replace(/^docs\//i, '');

  const candidates = [];

  const addCandidate = (url) => {
    if (url && !candidates.includes(url)) {
      candidates.push(url);
    }
  };

  // If DB already stores uploads/..., use it exactly first.
  if (/^uploads\//i.test(encodedPath)) {
    addCandidate(`${origin}/${encodedPath}`);
  }

  // If DB stores docs/filename.pdf.
  if (/^docs\//i.test(withoutUploads)) {
    addCandidate(`${origin}/uploads/${withoutUploads}`);
  }

  // Fallbacks for older records / filename-only records.
  addCandidate(`${origin}/uploads/docs/${withoutDocs}`);
  addCandidate(`${origin}/uploads/${withoutUploads}`);
  addCandidate(`${origin}/${encodedPath}`);

  return candidates;
};

const fetchDocumentFile = async (filePath) => {
  const candidates = getDocumentUrlCandidates(filePath);
  let lastError = null;

  for (const url of candidates) {
    try {
      console.log('Trying document URL:', url);

      const response = await fetch(url, {
        method: 'GET',
        cache: 'no-store'
      });

      if (!response.ok) {
        lastError = new Error(`HTTP ${response.status}`);
        continue;
      }

      const blob = await response.blob();

      const contentType =
        (response.headers.get('content-type') || '').toLowerCase();

      const signature = await blob.slice(0, 5).text();

      const isPdf =
        contentType.includes('application/pdf') ||
        blob.type.toLowerCase().includes('application/pdf') ||
        signature === '%PDF-';

      if (isPdf && blob.size > 0) {
        return { url, blob };
      }

      lastError = new Error(
        `Non-PDF response: ${contentType || 'unknown'}, ${blob.size} bytes`
      );
    } catch (error) {
      lastError = error;
    }
  }

  throw lastError || new Error('Document file not found');
};

const getDocumentFileName = (doc) => {
  const storedFileName = String(doc?.file || '')
    .replace(/\\/g, '/')
    .split('/')
    .pop();

  if (storedFileName) {
    try {
      return decodeURIComponent(storedFileName);
    } catch {
      return storedFileName;
    }
  }

  const name = String(doc?.name || 'document').trim();
  return name.toLowerCase().endsWith('.pdf')
    ? name
    : `${name}.pdf`;
};

// View button for ALL regular document tabs.
const handleView = async (doc) => {
  if (!doc?.file) {
    alert('File path is missing for this document');
    return;
  }

  // Open immediately so popup blockers do not block after await.
  const viewer = window.open('', '_blank');

  if (!viewer) {
    alert('Please allow pop-ups to view this document');
    return;
  }

  try {
    viewer.document.write(
      '<div style="font-family:Arial;padding:20px">Loading document...</div>'
    );

    const { url } = await fetchDocumentFile(doc.file);
    viewer.location.href = url;
  } catch (error) {
    console.error('View error:', error);
    viewer.close();
    alert(
      'Unable to view file. The saved PDF path may be incorrect or the file is missing on the server.'
    );
  }
};

// Download button for ALL regular document tabs.
const handleDownload = async (doc) => {
  if (!doc?.file) {
    alert('File path is missing for this document');
    return;
  }

  try {
    const { blob } = await fetchDocumentFile(doc.file);
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = getDocumentFileName(doc);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1000);
  } catch (error) {
    console.error('Download error:', error);
    alert(
      'Unable to download file. The saved PDF path may be incorrect or the file is missing on the server.'
    );
  }
};

const handleTenderDownload = async () => {
  try {
    const response = await fetch(
      `https://crd-training.in/tender.pdf?v=${Date.now()}`,
      { cache: 'no-store' }
    );

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = 'Procurement_of_Manpower_Service.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1000);
  } catch (error) {
    console.error('Tender download error:', error);
    alert('Unable to download tender PDF');
  }
};

const handleTenderView = () => {
  window.open('https://crd-training.in/tender.pdf', '_blank');
};

  // CSS styles for animations
  const blinkingStyle = {
    animation: 'blink 1.5s linear infinite'
  };

  const bounceStyle = {
    animation: 'bounce 2s infinite'
  };

  return (
    <div className="flex flex-col min-h-screen">
      {/* Add CSS animations */}
      <style jsx>{`
        @keyframes blinkBounce {
          0%, 20%, 53%, 80%, 100% {
            transform: translateY(0);
            color: #2563eb;
            opacity: 1;
          }
          10%, 30% {
            color: #1e40af;
            opacity: 0.8;
          }
          40%, 43% {
            transform: translateY(-8px);
            color: #2563eb;
          }
          70% {
            transform: translateY(-4px);
            color: #1e40af;
          }
          90% {
            transform: translateY(-2px);
            color: #2563eb;
          }
        }
        
        @keyframes bounce {
          0%, 20%, 53%, 80%, 100% {
            transform: translateY(0);
          }
          40%, 43% {
            transform: translateY(-10px);
          }
          70% {
            transform: translateY(-5px);
          }
          90% {
            transform: translateY(-2px);
          }
        }
        
        .blinking-tender {
          animation: blinkBounce 2s linear infinite;
        }
        
        .bouncing-download {
          animation: bounce 2s infinite;
        }
      `}</style>

      <Header />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <section className="relative py-10 bg-blue-800">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-2xl md:text-3xl font-bold text-white">Documents & Downloads</h1>
              <div className="h-0.5 w-16 bg-white mt-2 mb-4"></div>
              <p className="text-white">
                Access and download official documents, forms, reports, guidelines, and tenders
              </p>
            </div>
          </div>
        </section>
        
        {/* Category Filter Section */}
        <section className="py-4 bg-gray-100 border-b border-gray-200">
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap gap-2 md:gap-3">
              {categories.map(category => (
                <button
                  key={category.id}
                  onClick={() => setActiveCategory(category.id)}
                  className={`px-3 py-1 rounded-md text-sm transition-colors duration-200 ${
                    activeCategory === category.id 
                      ? 'bg-blue-600 text-white' 
                      : 'bg-white text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {category.name}
                </button>
              ))}
            </div>
          </div>
        </section>
        
        {/* Documents List Section */}
        <section className="py-8 bg-white">
          <div className="container mx-auto px-4">
            <div className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden">
              {loading && activeCategory !== 'tenders' ? (
                <div className="py-12 text-center">
                  <svg className="animate-spin h-8 w-8 text-blue-500 mx-auto mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  <p className="text-gray-600">Loading documents...</p>
                </div>
              ) : error && activeCategory !== 'tenders' ? (
                <div className="py-12 text-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto text-red-400 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <p className="text-red-600 mb-4">{error}</p>
                  <button 
                    onClick={fetchDocuments}
                    className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                  >
                    Try Again
                  </button>
                </div>
              ) : (
                <>
                  {/* Table Header */}
                  <div className="grid grid-cols-12 gap-4 bg-gray-50 p-4 border-b border-gray-200 hidden md:grid">
                    <div className="col-span-6 text-sm font-medium text-gray-700">Document Title</div>
                    <div className="col-span-2 text-sm font-medium text-gray-700">Category</div>
                    <div className="col-span-2 text-sm font-medium text-gray-700">Date</div>
                    <div className="col-span-2 text-sm font-medium text-gray-700 text-right">Actions</div>
                  </div>
                  
                  {/* Documents List */}
                  {filteredDocuments.map((document, index) => (
                    <div 
                      key={document.id}
                      className={`grid grid-cols-1 md:grid-cols-12 gap-3 p-4 ${
                        index !== filteredDocuments.length - 1 ? 'border-b border-gray-200' : ''
                      } hover:bg-blue-50 transition-colors duration-150`}
                    >
                      {/* Mobile and Desktop view - document info */}
                      <div className="col-span-1 md:col-span-6 flex items-start">
                        <div className="bg-blue-100 p-2 rounded-md mr-3 hidden md:block">
                          {activeCategory === 'tenders' ? (
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                          ) : (
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                            </svg>
                          )}
                        </div>
                        <div>
                          <h3 className={`font-medium ${
                            activeCategory === 'tenders' || document.category === 'TENDERS' 
                              ? 'blinking-tender text-blue-600' 
                              : 'text-gray-800'
                          }`}>
                            {document.name}
                          </h3>
                          {document.description && (
                            <p className="text-sm text-gray-500 mt-1">{document.description}</p>
                          )}
                          <div className="flex items-center mt-1 md:hidden">
                            <span className="text-xs text-blue-500 bg-blue-50 px-2 py-0.5 rounded mr-2">
                              {document.category}
                            </span>
                            <span className="text-xs text-gray-500">
                            {formatDate(document.date)}
                            </span>
                          </div>
                        </div>
                      </div>
                      
                      {/* Category - desktop only */}
                      <div className="hidden md:flex md:col-span-2 items-center">
                        <span className="text-sm font-medium text-blue-600 bg-blue-50 px-3 py-1 rounded-lg">
                          {document.category}
                        </span>
                      </div>

                      {/* Date - desktop only */}
                      <div className="hidden md:flex md:col-span-2 items-center">
                        <span className="text-sm text-gray-600">
                     {formatDate(document.date)}
                        </span>
                      </div>
                      
                      {/* Action Buttons */}
                      <div className="col-span-1 md:col-span-2 flex justify-end items-center gap-2">
                        {activeCategory === 'tenders' || document.category === 'TENDERS' ? (
                          <>
                            {/* View Button for Tenders */}
                            <button
                              onClick={() => handleTenderView(document)}
                              className="inline-flex items-center justify-center px-3 py-1.5 bg-green-600 hover:bg-green-700 text-white text-sm rounded-md transition-colors duration-200"
                              title="View PDF"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                              </svg>
                              <span className="hidden sm:inline ml-1">View</span>
                            </button>
                            
                            {/* Download Button for Tenders with Bouncing Text */}
                            <button
                              onClick={() => handleTenderDownload(document)}
                              className="inline-flex items-center justify-center px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded-md transition-colors duration-200"
                              title="Download PDF"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                              </svg>
                              <span className="hidden sm:inline ml-1 bouncing-download">Click here to download</span>
                              <span className="sm:hidden bouncing-download">Download</span>
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              onClick={() => handleView(document)}
                              className="inline-flex items-center justify-center px-3 py-1.5 bg-green-600 hover:bg-green-700 text-white text-sm rounded-md transition-colors duration-200"
                              title="View PDF"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                              </svg>
                              <span className="hidden sm:inline ml-1">View</span>
                            </button>

                            <button
                              onClick={() => handleDownload(document)}
                              className="inline-flex items-center justify-center px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded-md transition-colors duration-200"
                              title="Download PDF"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                              </svg>
                              <span className="hidden sm:inline">Download</span>
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  ))}
                  
                  {/* Empty state */}
                  {filteredDocuments.length === 0 && !loading && (
                    <div className="py-12 text-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto text-gray-400 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      <p className="text-gray-600">
                        {activeCategory === 'tenders' 
                          ? 'No tenders available at the moment'
                          : 'No documents found with the selected filters'
                        }
                      </p>
                      {activeCategory !== 'all' && activeCategory !== 'tenders' && (
                        <button
                          onClick={() => setActiveCategory('all')}
                          className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-blue-600 bg-blue-50 hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        >
                          View All Documents
                        </button>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default DocumentsPage;